<app-search-result-card>
  <div header class="position-relative">
    <img
      class="card-img-top"
      [src]="result.thumbnailUrl ?? placeholder"
      [alt]="result.title"
      (error)="$event.target.src = placeholder">
    <div class="card-img-overlay d-flex align-items-center">
      <a
        class="play-button display-6 mx-auto stretched-link"
        [href]="result.url">
        <span class="material-symbols-outlined">play_circle</span>
      </a>
    </div>
  </div>

  @if (result.source === Source.CLOUD_LEARNING_CONTENT && result.learningPathName) {
    <app-ellipsis [lines]="2" class="course-name-wrapper mb-1">
      <a
        class="fw-semibold small text-decoration-none text-gray-600"
        [href]="result.learningPathId | universityLearningPathUrl">
        <span class="material-symbols-outlined">route</span>
        {{ result.learningPathName }}
      </a>
    </app-ellipsis>
  }

  <app-ellipsis [lines]="3">
    <a
      class="h5 text-break text-decoration-none text-lightblue-700"
      [href]="result.url">{{ result.title }}</a>
  </app-ellipsis>
</app-search-result-card>
